import React from "react"

export const MultiUser = ({ height = 24, width = 24, fill = "currentColor", ...props }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18 21C18 18.8783 17.1571 16.8434 15.6569 15.3431C14.1566 13.8429 12.1217 13 10 13C7.87827 13 5.84344 13.8429 4.34315 15.3431C2.84285 16.8434 2 18.8783 2 21"
      stroke='currentColor'
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 13C12.7614 13 15 10.7614 15 8C15 5.23858 12.7614 3 10 3C7.23858 3 5 5.23858 5 8C5 10.7614 7.23858 13 10 13Z"
      stroke='currentColor'
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.0008 20.0002C22.0008 16.6302 20.0008 13.5002 18.0008 12.0002C18.6582 11.507 19.1839 10.8593 19.5313 10.1145C19.8788 9.36965 20.0373 8.55066 19.9928 7.73C19.9483 6.90933 19.7022 6.11228 19.2763 5.40939C18.8503 4.70651 18.2577 4.11946 17.5508 3.7002"
      stroke='currentColor'
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default MultiUser
